import React, { useEffect, useRef, useState } from "react";
import { Settings } from "../Settings/Index";
import PublishStream from "../../libs/DolbyStreaming/PublishStream";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import noiseReduction from "../../assets/images/noise-reduction-icon.svg";
import speakerIcon from "../../assets/images/speaker-icon.png";
import microphoneIcon from "../../assets/images/microphone-icon.png";
import AudioInputSelector from "../SelectDeviceComponents/AudioInputSelector";
import AudioOutputSelector from "../SelectDeviceComponents/AudioOutputSelector";
import dropdownArrow from "../../assets/images/dropdown-arrow-icon.svg";
import endSession from "../../assets/images/end-session.svg";
import leaveSession from "../../assets/images/leave-session.svg";
import youTubeIcon from "../../assets/images/youtube-icon.svg";
import facebookIcon from "../../assets/images/facebook-icon-sq.svg";
import linkdinIcon from "../../assets/images/linkdin-icon.svg";
import Invite from "../Invite/Invite";
import { postRequest } from "../../libs/APIs/apiCall";
import { setAuthToken } from "../../libs/APIs/auth";
import { ToastContainer, toast } from "react-toastify";
import {
  cameraToggle,
  muteToggle,
  updateisInvitePopUp,
  updateIsLive,
  updateIsLiveGo,
  updateIsScreen,
  updateNoiseReduction,
} from "../../Store/Actions/PublishStreamAction";
import { usePubNub } from "pubnub-react";
import { signalEnum } from "../../libs/signal/signalEnum";
import { EasyCastPopup } from "../EasyCastPopup/EasyCastPopup";
import { ConfirmationPopup } from "../LiveRoomPopUp/ConfirmationPopup ";
import {
  PublishStreamState,
  RootState,
} from "../../Store/Reducers/PublishStreamReducer";
import LoaderEnd from "../Loader/LoaderEnd";
import { ScreenShareDeniedPopup } from "../PopUp/ScreenShareDeniedPopup/ScreenShareDeniedPopup";
import { formatTime } from "../../libs/UtilityFunctions/UtilFunctions";
import { pollStatus } from "../Polls/poll-enum";
import VideoInputSelector from "../SelectDeviceComponents/VideoInputSelector";
import { CameraSettings } from "../Settings/CameraSettings";
interface props {
  stopStreamTotally: () => void;
  isScreenSharedByPresentor: boolean;
}

export const Header = ({
  stopStreamTotally,
  isScreenSharedByPresentor,
}: props) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false);
  const [isEndSessionOrLeave, setIsEndSessionOrLeave] = useState<string>("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  //Redux start
  const stateData = useSelector(
    (state: RootState) => state.PublishStreamReducer
  );

  // console.log(stateData  => , "stateData");
  const [isToggled, setIsToggled] = useState(
    stateData?.publishStreamObj?.isNoiseReductionEnabled
  );
  const dispatch = useDispatch();
  const obj: PublishStream = stateData?.publishStreamObj?.obj;
  const handleIsLiveClick = () => {
    dispatch(updateIsLive(true));

    //update pubnub channel state start
    const ChatchannelName =
      "Webinar." +
      stateData.publishStreamObj.webinarid +
      "." +
      stateData.publishStreamObj.sessionId;

    pubnubobj.objects.setChannelMetadata({
      channel: ChatchannelName,
      data: {
        name: "Webinar",
        description: "Webinar Status",
        custom: {
          webinarId: stateData.publishStreamObj.webinarid,
          sessionId: stateData.publishStreamObj.sessionId,
          satus: "liveroom",
        },
      },
    });
    //end
  };

  // console.log(IsLiveGo, 'IsLiveGo')
  const IsScreeen = stateData?.publishStreamObj?.isScreen;
  // console.log(IsScreeen, 'IsScreeen')
  const isInvitePopUp = stateData?.publishStreamObj?.isInvitePopUp;
  // console.log(isInvitePopUp,"isInvitePopUp")
  // console.log(stateData.publishStreamObj.event_name, "remove")
  //State managemenet
  const [muted, setMuted] = useState(stateData?.publishStreamObj?.muted);
  const [video, setVideo] = useState(stateData?.publishStreamObj?.camera);

  //pubnub start
  const pubnubobj = usePubNub();
  const channelName = `${
    "Chat." +
    stateData.publishStreamObj.webinarid +
    "." +
    stateData.publishStreamObj.sessionId
  }`;

  //pubnub end

  //Live start
  // const goToLive = async () => {
  //   setAuthToken(
  //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3MTk1ODAwNDQsImV4cCI6MTcxOTU5NDQ0NCwiZGF0YSI6eyJ1c2VybmFtZSI6InRlc3QgdXNlciIsInVzZXJfaWQiOjc5MzksImV4cG9ydF9saW1pdCI6IjIwMCJ9fQ.RDuRkE_xZH_pJwJE2nIe6EFhENbn1v7groY1H4PjjSY"
  //   );
  //   const res = await postRequest(
  //     "https://test-v2.easywebinar.com/v1/easywebinar/v1/owner/webinar-status",
  //     {
  //       webinar_id: stateData?.publishStreamObj.webinarid,
  //       status: "running",
  //     }
  //   );
  // };
  //Live end

  //setting popup start
  const [activeTabProp, setactiveTabProp] = React.useState(1);
  const [isSettingPopupOpen, setIsSettingPopupOpen] = React.useState(false);
  const [isInvitePopupOpen, setIsInvitePopupOpen] = React.useState(false);
  const [time, setTime] = useState(0);
  const [isEasyCastOpen, setIsEasyCastOpen] = useState(false);
  const [isDropdownEasyCastActive, setIsDropdownEasyCastActive] =
    useState(false);
  const dropdownRef = useRef(null);

  const invitetogglePopupFunc = () => {
    setIsInvitePopupOpen(false);
  };

  const goToSettings = () => {
    setIsSettingPopupOpen(true);
  };

  const goToInvite = () => {
    dispatch(updateisInvitePopUp(true));
  };

  const settingTogglePopup = () => {
    setIsSettingPopupOpen(false);
  };

  const goToAudioSettings = () => {
    setactiveTabProp(2);
    setIsSettingPopupOpen(true);
  };

  const goToCameraSettings = () => {
    setactiveTabProp(1);
    setIsSettingPopupOpen(true);
  };
  //end

  // Youtube live - easycast popup
  const openEasyCastPopup = () => {
    setIsEasyCastOpen(true);
  };

  const closeEasyCastPopup = () => {
    setIsEasyCastOpen(false);
  };
  const toggleEasyCastDropdown = () => {
    setIsDropdownEasyCastActive(!isDropdownEasyCastActive);
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownEventActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // time format

  useEffect(() => {
    let timer;

    if (stateData?.publishStreamObj?.isLiveGo) {
      timer = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      setTime(0);
    }

    return () => {
      clearInterval(timer);
    };
  }, [stateData?.publishStreamObj?.isLiveGo]);

  //Mic on/off start
  const muteToggle1 = async () => {
    setMuted((pre) => !pre);
    await obj.streamMicUpdate(muted);
    // dispatch({
    //   type: "AUDIO_TOGGLE",
    //   payload: {
    //     ...stateData?.publishStreamObj,
    //     muted: !stateData?.publishStreamObj?.muted,
    //   },
    // });

    dispatch(muteToggle(!stateData?.publishStreamObj?.muted));
    pubnubobj
      .signal({
        message: {
          // uuid: stateData?.publishStreamObj?.userUUID,
          mic: muted,
        },
        channel: channelName,
      })
      .catch((error) => {
        console.error("Error sending mute signal:", error);
        console.error("Error status:", error.status); // Log the status code or status object
        console.error("Error message:", error.message);
      });
  };
  //end

  //Video on/off start
  const videoToggle = async () => {
    const newVideoState = !video;
    setVideo(newVideoState);
    await obj.streamCameraUpdate(newVideoState);

    dispatch(cameraToggle(!stateData?.publishStreamObj?.camera));

    pubnubobj
      .signal({
        message: {
          camera: newVideoState,
        },
        channel: channelName,
      })
      .catch((error) => {
        console.error("Error sending mute signal:", error);
        console.error("Error status:", error.status); // Log the status code or status object
        console.error("Error message:", error.message);
      });
  };
  //end

  // screen share code start here
  const [isScreenShareDeniedOpen, setisScreenShareDeniedOpen] = useState(false);
  function onScreenShareDeniedClose() {
    setisScreenShareDeniedOpen(false);
  }
  const toggleScreenShare = async () => {
    if (isScreenSharedByPresentor == false) {
      dispatch(updateIsScreen(true));
      await obj.startScreenShare(
        stateData?.publishStreamObj?.userName,
        stateData?.publishStreamObj?.bitrate
      );
      // dispatch(updateIsScreen(true));
      //pubnub signal start
      const WebinarchannelName =
        "Webinar." +
        stateData.publishStreamObj.webinarid +
        "." +
        stateData.publishStreamObj.sessionId;
      pubnubobj.signal({
        message: {
          name: stateData?.publishStreamObj?.userName,
          screen: true,
        },
        channel: WebinarchannelName,
      });
      //end
    } else {
      setisScreenShareDeniedOpen(true);
    }
  };

  function stopScreenShare() {
    const obj: PublishStream = stateData?.publishStreamObj?.obj;
    obj.stopSreenShare();
    dispatch(updateIsScreen(false));
  }
  //end

  //Update redux stats start
  useEffect(() => {
    setVideo(stateData?.publishStreamObj?.camera);
  }, [stateData?.publishStreamObj?.camera]);

  useEffect(() => {
    setMuted(stateData?.publishStreamObj?.muted);
  }, [stateData?.publishStreamObj?.muted]);
  //end

  const [isDropdownMicActive, setIsDropdownMicActive] = useState(false);
  const toggleMicDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownMicActive(!isDropdownMicActive);
    setIsDropdownCameraActive(false);
  };
  const closeMicDropDown = () => {
    setIsDropdownMicActive(false);
  };

  const [isDropdownCameraActive, setIsDropdownCameraActive] = useState(false);
  const toggleCameraDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownCameraActive(!isDropdownCameraActive);
    setIsDropdownMicActive(false);
  };
  const closeCameraDropDown = () => {
    setIsDropdownCameraActive(false);
  };

  //volume up and down
  const [volume, setVolume] = React.useState(1);
  const handleVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(event.target.value) / 100;
    setVolume(newVolume);
    //handleVolumeChange(newVolume);

    dispatch({
      type: "VIDEO_TOGGLE",
      payload: {
        ...stateData?.publishStreamObj,
        speakerVolume: newVolume,
      },
    });
  };

  // Leave green room start
  const [isDropdownEventActive, setIsDropdownEventActive] = useState(false);
  const toggleExitDropdown = () => {
    setIsDropdownEventActive(!isDropdownEventActive);
  };

  // Leave green room start
  const leaveroom = async () => {
    await obj.leaveGreenRoom();
    localStorage.removeItem("Blocked")
    if (stateData.publishStreamObj.isAdmin) {

      stopStreamTotally();
      const baseUrl = "https://test-v2.easywebinar.com/webinar-live-end"; // Target URL
      const newUrl = `${baseUrl}?id=${stateData.publishStreamObj?.webinarid}`;

      try {
        const res = await postRequest(
          "https://test-v2.easywebinar.com/v1/easywebinar/v1/admin/exit-green-room",
          {
            sid: stateData?.publishStreamObj?.sid,
            webinar_id: stateData?.publishStreamObj.webinarid,
          }
        );
        // console.log(res);
        window.location.href = newUrl;
      } catch (error) {
        console.log("error");
        window.location.href = newUrl;
      }

      //If admin then end the session on green room
      const ChatchannelName =
        "Webinar." +
        stateData.publishStreamObj.webinarid +
        "." +
        stateData.publishStreamObj.sessionId;
      if (!stateData.publishStreamObj.isLiveGo) {
        pubnubobj.signal({
          message: {
            type: signalEnum.ENDSESSION,
            status: true,
          },
          channel: ChatchannelName,
        });
      }
    } else {

      if(stateData.publishStreamObj.isPresenter){

        stateData?.publishStreamObj?.obj?.mediaStreamm
        ?.getTracks()
        .forEach((track) => track.stop());
        stopStreamTotally();

      }

     
      navigate("/Thanks");
    }
  };

  const apiRequestAtEndSession = async () => {
    try {
      const res = await postRequest(
        "https://test-v2.easywebinar.com/v1/easywebinar/v1/admin/end-live-session",
        {
          sid: stateData?.publishStreamObj?.sid,
          webinar_id: stateData?.publishStreamObj.webinarid,
          did: stateData?.publishStreamObj?.did,
        }
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  const leaveSessionHandle = async () => {
    setLoading(true);
    // onCloseConfirmationPopUp()



    if (stateData?.publishStreamObj?.isAdmin) {
      apiRequestAtEndSession();
    }
    stopStreamTotally();

    //Publish signal
    stateData?.publishStreamObj?.obj?.mediaStreamm
      ?.getTracks()
      .forEach((track) => track.stop());
    await obj.leaveGreenRoom();

    pubnubobj.signal({
      message: {
        type: signalEnum.ENDSESSION,
        status: true,
      },
      channel: channelName,
    });

    const liveRoomChannel = `${
      "live-room-" + stateData.publishStreamObj.webinarid
    }`;
    pubnubobj.objects
      .setChannelMetadata({
        channel: liveRoomChannel,
        data: {
          status: "ended",
          custom: {
            session_id: stateData.publishStreamObj.sessionId,
          },
        },
      })
      .then((response) => {
        console.log("status updated to live for webinar:");
      })
      .catch((error) => {
        console.log("Unable to set channel status to live", error);
      });

    //update pubnub channel state start
    const ChatchannelName =
      "Webinar." +
      stateData.publishStreamObj.webinarid +
      "." +
      stateData.publishStreamObj.sessionId;

    pubnubobj.signal({
      message: {
        type: signalEnum.ENDSESSION,
        status: true,
      },
      channel: ChatchannelName,
    });
    //signal end session end

    //update pubnub channel state start
    pubnubobj.objects.setChannelMetadata({
      channel: ChatchannelName,
      data: {
        name: "Webinar",
        description: "Webinar Status",
        custom: {
          webinarId: stateData.publishStreamObj.webinarid,
          sessionId: stateData.publishStreamObj.sessionId,
          satus: "end",
        },
      },
    });

    //setting pubnub meta deta for closed polls status

    let globalPollChannel =
      "Polls" +
      "." +
      stateData.publishStreamObj.webinarid +
      "." +
      stateData.publishStreamObj.sessionId;

    pubnubobj.objects
      .getChannelMetadata({
        channel: globalPollChannel,
      })
      .then((response) => {
        let activePoll = response.data.custom.activePoll;
        if (activePoll) {
          pubnubobj.objects.setChannelMetadata({
            channel: `Polls.${stateData.publishStreamObj.sessionId}.${activePoll}`,
            data: {
              status: pollStatus.closed,
            },
          });
        }
      });

    // setLoading(false)
    //end
  };

  // apiRequestAtEndSession()
  //end

  const stopStream = async () => {
    navigate("/");
  };
  //end

  useEffect(() => {
    // Close the pop-up when clicking anywhere on the screen
    const handleDocumentClick = () => {
      closeMicDropDown();
      closeCameraDropDown();
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const onOpenConfirmationModel = (value: string) => {
    setIsEndSessionOrLeave(value);
    toggleExitDropdown();
    setIsConfirmationOpen(true);
  };

  const onCloseConfirmationPopUp = () => {
    setIsConfirmationOpen(false);
  };

  const handleEnableNoiseReduction = async () => {
    const newToggleState = !isToggled;
    setIsToggled(newToggleState);
    dispatch(updateNoiseReduction(newToggleState));

    try {
      await obj.noiseReductionUpdate(
        newToggleState,
        stateData?.publishStreamObj?.deviceId,
        stateData?.publishStreamObj?.speakerdeviceId,
        stateData?.publishStreamObj?.cameraId,
        stateData?.publishStreamObj?.muted
      );
      toast.success(
        `Noise reduction ${newToggleState ? "enabled" : "disabled"}`,
        {
          autoClose: 500,
        }
      );
    } catch (error) {
      console.error("Error updating noise reduction:", error);
      toast.error("Failed to update noise reduction", {
        autoClose: 500,
      });
    }
  };

  //Webinar status start punbun
  const WebinachannelName =
    "Webinar." +
    stateData.publishStreamObj.webinarid +
    "." +
    stateData.publishStreamObj.sessionId;
  const liveRoomChannel = `${
    "live-room-" + stateData.publishStreamObj.webinarid
  }`;

  useEffect(() => {
    pubnubobj.objects
      .getChannelMetadata({
        channel: WebinachannelName,
      })
      .then((response) => {
        console.log("Webinar status:", response);
        if (response.data.custom?.satus == "liveroom") {
          dispatch(updateIsLiveGo(true));
        }
      })
      .catch((error) => {
        console.error("Error getting metadata:", error);
      });

    pubnubobj.objects
      .getChannelMetadata({
        channel: liveRoomChannel,
      })
      .then((response) => {
        if (response.data.custom?.status == "live") {
          setTime((pre) => pre * 0);
          let prevTimeStamp = response.data.custom?.currentTimestamp;
          if (typeof prevTimeStamp !== "number") {
            prevTimeStamp = Number(prevTimeStamp); // Convert to number if possible
            if (isNaN(prevTimeStamp)) {
              // Handle the case where conversion fails
              console.error(
                "Invalid timestamp received:",
                response.data.custom?.currentTimestamp
              );
              return;
            }
          }

          const currentTimestamp = Date.now();
          const diffInMilliseconds = currentTimestamp - prevTimeStamp;
          const diffInSeconds = Math.floor(diffInMilliseconds / 1000);

          setTime(diffInSeconds);
        }
      })
      .catch((error) => {
        console.error("Error getting metadata:", error);
      });
  }, []);
  //end pubnub

  if (loading) {
    return <LoaderEnd />;
  }

  return (
    <>
      <div className="layout-header flex flex-align-center flex-justify-between">
        <div className="flex flex-align-center overflow-hidden">
          <span className="ew-logo hide-on-mobile">
            <svg
              width="57"
              height="55"
              viewBox="0 0 57 55"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Logo-Symbol" clip-path="url(#clip0_1147_18554)">
                <path
                  id="Rounded Rectangle 1"
                  d="M49.875 0H7.125C3.18997 0 0 3.2119 0 7.17397V47.826C0 51.7881 3.18997 55 7.125 55H49.875C53.81 55 57 51.7881 57 47.826V7.17397C57 3.2119 53.81 0 49.875 0Z"
                  fill="#22B060"
                />
                <g id="Group 694">
                  <path
                    id="Shape 1"
                    d="M39.5517 15L46.0574 15.0957C46.0574 15.0957 36.6654 27.9366 46.184 41.2393H39.4567C39.4567 41.2393 34.6716 37.053 34.5308 28.5672C34.5297 28.5684 34.3877 20.1829 39.5517 15Z"
                    fill="white"
                  />
                  <path
                    id="Shape 1 copy 3"
                    d="M27.7883 15L34.294 15.0957C34.294 15.0957 24.902 27.9366 34.4206 41.2393H27.6933C27.6933 41.2393 22.9082 37.053 22.7675 28.5672C22.7675 28.5684 22.6256 20.1829 27.7883 15Z"
                    fill="white"
                  />
                  <path
                    id="Shape 1 copy 4"
                    d="M16.0202 15L22.5259 15.0957C22.5259 15.0957 13.1339 27.9366 22.6526 41.2393H15.9264C15.9264 41.2393 11.1413 37.053 11.0006 28.5672C10.9994 28.5684 10.8575 20.1829 16.0202 15Z"
                    fill="white"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_1147_18554">
                  <rect width="57" height="55" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <div className="ew-event-details">
            <h3 className="ew-event-title">
              {stateData.publishStreamObj.event_name}
            </h3>
            <span
              className={`not-live-label flex-justify-center flex-align-center not-live-label ${
                stateData?.publishStreamObj?.isLiveGo
                  ? "event-live"
                  : "event-not-live"
              }`}
            >
              <span className="status-sign"></span>{" "}
              {stateData?.publishStreamObj?.isLiveGo ? "LIVE " : "OFF AIR"}
              <span className="event-time">{formatTime(time)}</span>
            </span>
            <span></span>
          </div>
        </div>
        <div className="flex flex-align-center">
          <div className="flex event-option-menu">
            <ul className="flex flex-align-center">
              <li
                className="flex flex-align-center flex-justify-center"
                onClick={goToSettings}
              >
                <a className="test">
                  <span className="menu-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.2529 12.5696V11.4221L21.6929 10.1621C21.9583 9.92811 22.1325 9.60784 22.1847 9.25787C22.2368 8.9079 22.1636 8.55076 21.9779 8.24957L20.2079 5.24957C20.0764 5.02177 19.8872 4.83256 19.6595 4.70092C19.4318 4.56928 19.1734 4.49984 18.9104 4.49957C18.7474 4.49832 18.5852 4.52366 18.4304 4.57457L16.6079 5.18957C16.2932 4.98048 15.965 4.79256 15.6254 4.62707L15.2429 2.73707C15.1743 2.39178 14.9864 2.0816 14.7122 1.86085C14.438 1.6401 14.0949 1.52283 13.7429 1.52957H10.2329C9.8809 1.52283 9.53776 1.6401 9.26353 1.86085C8.98931 2.0816 8.80146 2.39178 8.73288 2.73707L8.35038 4.62707C8.00833 4.79252 7.6776 4.98043 7.36038 5.18957L5.57538 4.54457C5.41885 4.50379 5.25675 4.48859 5.09538 4.49957C4.83233 4.49984 4.57398 4.56928 4.34625 4.70092C4.11851 4.83256 3.9294 5.02177 3.79787 5.24957L2.02788 8.24957C1.85282 8.55031 1.78776 8.90257 1.84386 9.246C1.89996 9.58943 2.07372 9.90267 2.33537 10.1321L3.75287 11.4296V12.5771L2.33537 13.8371C2.06633 14.0681 1.88782 14.3869 1.83152 14.737C1.77523 15.0871 1.8448 15.4459 2.02788 15.7496L3.79787 18.7496C3.9294 18.9774 4.11851 19.1666 4.34625 19.2982C4.57398 19.4299 4.83233 19.4993 5.09538 19.4996C5.25839 19.5008 5.42051 19.4755 5.57538 19.4246L7.39787 18.8096C7.71253 19.0187 8.04076 19.2066 8.38037 19.3721L8.76288 21.2621C8.83146 21.6074 9.01931 21.9175 9.29353 22.1383C9.56776 22.3591 9.9109 22.4763 10.2629 22.4696H13.8029C14.1549 22.4763 14.498 22.3591 14.7722 22.1383C15.0464 21.9175 15.2343 21.6074 15.3029 21.2621L15.6854 19.3721C16.0274 19.2066 16.3581 19.0187 16.6754 18.8096L18.4904 19.4246C18.6452 19.4755 18.8074 19.5008 18.9704 19.4996C19.2334 19.4993 19.4918 19.4299 19.7195 19.2982C19.9472 19.1666 20.1364 18.9774 20.2679 18.7496L21.9779 15.7496C22.1529 15.4488 22.218 15.0966 22.1619 14.7532C22.1058 14.4097 21.932 14.0965 21.6704 13.8671L20.2529 12.5696ZM18.9104 17.9996L16.3379 17.1296C15.7357 17.6397 15.0474 18.0384 14.3054 18.3071L13.7729 20.9996H10.2329L9.70038 18.3371C8.96419 18.0608 8.27966 17.6627 7.67537 17.1596L5.09538 17.9996L3.32537 14.9996L5.36538 13.1996C5.2267 12.4232 5.2267 11.6284 5.36538 10.8521L3.32537 8.99957L5.09538 5.99957L7.66788 6.86957C8.27008 6.35949 8.95833 5.96076 9.70038 5.69207L10.2329 2.99957H13.7729L14.3054 5.66207C15.0416 5.93839 15.7261 6.33643 16.3304 6.83957L18.9104 5.99957L20.6804 8.99957L18.6404 10.7996C18.7791 11.5759 18.7791 12.3707 18.6404 13.1471L20.6804 14.9996L18.9104 17.9996Z"
                        fill="#666666"
                      />
                      <path
                        d="M12 16.5C11.11 16.5 10.24 16.2361 9.49994 15.7416C8.75991 15.2471 8.18314 14.5443 7.84254 13.7221C7.50195 12.8998 7.41283 11.995 7.58647 11.1221C7.7601 10.2492 8.18868 9.44736 8.81802 8.81802C9.44736 8.18868 10.2492 7.7601 11.1221 7.58647C11.995 7.41283 12.8998 7.50195 13.7221 7.84254C14.5443 8.18314 15.2471 8.75991 15.7416 9.49994C16.2361 10.24 16.5 11.11 16.5 12C16.506 12.5926 16.3937 13.1805 16.1697 13.7292C15.9457 14.2779 15.6145 14.7763 15.1954 15.1954C14.7763 15.6145 14.2779 15.9457 13.7292 16.1697C13.1805 16.3937 12.5926 16.506 12 16.5ZM12 9C11.6035 8.99077 11.2093 9.06205 10.8411 9.20954C10.473 9.35704 10.1386 9.57768 9.85812 9.85812C9.57768 10.1386 9.35704 10.473 9.20954 10.8411C9.06205 11.2093 8.99077 11.6035 9 12C8.99077 12.3965 9.06205 12.7907 9.20954 13.1589C9.35704 13.527 9.57768 13.8615 9.85812 14.1419C10.1386 14.4223 10.473 14.643 10.8411 14.7905C11.2093 14.938 11.6035 15.0092 12 15C12.3965 15.0092 12.7907 14.938 13.1589 14.7905C13.527 14.643 13.8615 14.4223 14.1419 14.1419C14.4223 13.8615 14.643 13.527 14.7905 13.1589C14.938 12.7907 15.0092 12.3965 15 12C15.0092 11.6035 14.938 11.2093 14.7905 10.8411C14.643 10.473 14.4223 10.1386 14.1419 9.85812C13.8615 9.57768 13.527 9.35704 13.1589 9.20954C12.7907 9.06205 12.3965 8.99077 12 9Z"
                        fill="#666666"
                      />
                    </svg>
                  </span>
                  <span>Settings</span>
                </a>
              </li>
              {/* <li
                className="flex flex-align-center flex-justify-center"
                ref={dropdownRef}
              >
                <a href="#" onClick={toggleEasyCastDropdown}>
                  <span className="menu-icon">
                    <svg
                      width="20"
                      height="15"
                      viewBox="0 0 20 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.22204 0.200841C3.33074 0.0953572 3.47688 0.0373636 3.62833 0.0396139C3.77978 0.0418643 3.92413 0.104174 4.02964 0.212841C4.14443 0.333447 4.20734 0.494257 4.20488 0.660737C4.20241 0.827217 4.13475 0.986091 4.01644 1.10324C2.4649 2.67343 1.59593 4.79261 1.59844 7.00004C1.59844 9.38804 2.59444 11.5432 4.19524 13.072C4.25677 13.1293 4.30633 13.1982 4.34105 13.2748C4.37577 13.3514 4.39497 13.4341 4.39754 13.5181C4.4001 13.6021 4.38599 13.6858 4.356 13.7644C4.32602 13.8429 4.28076 13.9147 4.22284 13.9756C4.11961 14.0823 3.97886 14.1444 3.83052 14.1489C3.68217 14.1534 3.53792 14.0999 3.42844 13.9996C2.47081 13.1027 1.7077 12.0186 1.18648 10.8145C0.665252 9.61045 0.397026 8.3121 0.398443 7.00004C0.398443 4.34324 1.47844 1.93844 3.22204 0.200841ZM15.9804 1.10324C15.8623 0.985932 15.7949 0.826971 15.7926 0.660491C15.7904 0.494012 15.8535 0.333291 15.9684 0.212841C16.0739 0.104539 16.218 0.0424618 16.3692 0.0402124C16.5203 0.0379631 16.6662 0.0957252 16.7748 0.200841C17.6708 1.09182 18.3816 2.15131 18.8662 3.31825C19.3508 4.48518 19.5996 5.73648 19.5984 7.00004C19.5984 9.76004 18.4344 12.2488 16.5684 13.9996C16.459 14.0999 16.3147 14.1534 16.1664 14.1489C16.018 14.1444 15.8773 14.0823 15.774 13.9756C15.7163 13.9147 15.6712 13.843 15.6413 13.7646C15.6114 13.6861 15.5974 13.6026 15.6 13.5187C15.6025 13.4348 15.6217 13.3523 15.6563 13.2758C15.6909 13.1994 15.7403 13.1305 15.8016 13.0732C16.6235 12.2898 17.2776 11.3474 17.724 10.3034C18.1704 9.25939 18.3998 8.1355 18.3984 7.00004C18.4013 4.7922 17.5323 2.67372 15.9804 1.10324ZM5.35684 2.30804C5.46378 2.2062 5.60679 2.15101 5.75442 2.15461C5.90205 2.15821 6.0422 2.22031 6.14404 2.32724C6.39364 2.57684 6.36844 2.98724 6.12244 3.23924C5.14484 4.24704 4.5982 5.59598 4.59844 7.00004C4.59844 8.54804 5.25004 9.94484 6.29524 10.93C6.55924 11.1784 6.59524 11.6032 6.33724 11.8612C6.23835 11.9641 6.10369 12.0249 5.96116 12.0312C5.81864 12.0374 5.67917 11.9886 5.57164 11.8948C4.88746 11.2761 4.34057 10.5209 3.96625 9.67778C3.59193 8.83469 3.39851 7.92249 3.39844 7.00004C3.39712 6.12712 3.56961 5.26268 3.90584 4.45712C4.24208 3.65155 4.73533 2.92099 5.35684 2.30804ZM13.8744 3.23924C13.6284 2.98724 13.6032 2.57684 13.8528 2.32724C13.9547 2.22031 14.0948 2.15821 14.2425 2.15461C14.3901 2.15101 14.5331 2.2062 14.64 2.30804C15.2616 2.92099 15.7548 3.65155 16.091 4.45712C16.4273 5.26268 16.5998 6.12712 16.5984 7.00004C16.5987 7.9226 16.4055 8.83497 16.0314 9.67828C15.6573 10.5216 15.1106 11.2771 14.4264 11.896C14.3185 11.9902 14.1783 12.039 14.0352 12.0323C13.8921 12.0256 13.7571 11.9639 13.6584 11.86C13.4016 11.6032 13.4376 11.1784 13.7016 10.93C14.2374 10.4252 14.6643 9.81618 14.9561 9.14036C15.2479 8.46453 15.3984 7.73617 15.3984 7.00004C15.3987 5.59598 14.852 4.24704 13.8744 3.23924ZM9.99844 5.50004C9.60062 5.50004 9.21909 5.65808 8.93778 5.93938C8.65648 6.22069 8.49844 6.60222 8.49844 7.00004C8.49844 7.39787 8.65648 7.7794 8.93778 8.0607C9.21909 8.34201 9.60062 8.50004 9.99844 8.50004C10.3963 8.50004 10.7778 8.34201 11.0591 8.0607C11.3404 7.7794 11.4984 7.39787 11.4984 7.00004C11.4984 6.60222 11.3404 6.22069 11.0591 5.93938C10.7778 5.65808 10.3963 5.50004 9.99844 5.50004Z"
                        fill="#666666"
                      />
                    </svg>
                  </span>
                  <span>EasyCast</span>
                </a>
                {isDropdownEasyCastActive && (
                  <div
                    className={`ew-easycast ${
                      isDropdownEasyCastActive ? "open-dropdown" : ""
                    }`}
                  >
                    <ul className="flex">
                      <li className="flex">
                        <a href="#" onClick={openEasyCastPopup}>
                          <img src={youTubeIcon} alt="" /> Youtube
                        </a>
                      </li>
                      <li className="flex">
                        <a href="#">
                          <img src={facebookIcon} alt="" /> Facebook
                        </a>
                      </li>
                      <li className="flex">
                        <a href="#">
                          <img src={linkdinIcon} alt="" /> Linkdin
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </li> */}
              {/* <li
              className="flex flex-align-center flex-justify-center"
              onClick={goToInvite}
            >
              <a className="test">
                <span className="menu-icon">
                  <svg
                    width="20"
                    height="15"
                    viewBox="0 0 20 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.22204 0.200841C3.33074 0.0953572 3.47688 0.0373636 3.62833 0.0396139C3.77978 0.0418643 3.92413 0.104174 4.02964 0.212841C4.14443 0.333447 4.20734 0.494257 4.20488 0.660737C4.20241 0.827217 4.13475 0.986091 4.01644 1.10324C2.4649 2.67343 1.59593 4.79261 1.59844 7.00004C1.59844 9.38804 2.59444 11.5432 4.19524 13.072C4.25677 13.1293 4.30633 13.1982 4.34105 13.2748C4.37577 13.3514 4.39497 13.4341 4.39754 13.5181C4.4001 13.6021 4.38599 13.6858 4.356 13.7644C4.32602 13.8429 4.28076 13.9147 4.22284 13.9756C4.11961 14.0823 3.97886 14.1444 3.83052 14.1489C3.68217 14.1534 3.53792 14.0999 3.42844 13.9996C2.47081 13.1027 1.7077 12.0186 1.18648 10.8145C0.665252 9.61045 0.397026 8.3121 0.398443 7.00004C0.398443 4.34324 1.47844 1.93844 3.22204 0.200841ZM15.9804 1.10324C15.8623 0.985932 15.7949 0.826971 15.7926 0.660491C15.7904 0.494012 15.8535 0.333291 15.9684 0.212841C16.0739 0.104539 16.218 0.0424618 16.3692 0.0402124C16.5203 0.0379631 16.6662 0.0957252 16.7748 0.200841C17.6708 1.09182 18.3816 2.15131 18.8662 3.31825C19.3508 4.48518 19.5996 5.73648 19.5984 7.00004C19.5984 9.76004 18.4344 12.2488 16.5684 13.9996C16.459 14.0999 16.3147 14.1534 16.1664 14.1489C16.018 14.1444 15.8773 14.0823 15.774 13.9756C15.7163 13.9147 15.6712 13.843 15.6413 13.7646C15.6114 13.6861 15.5974 13.6026 15.6 13.5187C15.6025 13.4348 15.6217 13.3523 15.6563 13.2758C15.6909 13.1994 15.7403 13.1305 15.8016 13.0732C16.6235 12.2898 17.2776 11.3474 17.724 10.3034C18.1704 9.25939 18.3998 8.1355 18.3984 7.00004C18.4013 4.7922 17.5323 2.67372 15.9804 1.10324ZM5.35684 2.30804C5.46378 2.2062 5.60679 2.15101 5.75442 2.15461C5.90205 2.15821 6.0422 2.22031 6.14404 2.32724C6.39364 2.57684 6.36844 2.98724 6.12244 3.23924C5.14484 4.24704 4.5982 5.59598 4.59844 7.00004C4.59844 8.54804 5.25004 9.94484 6.29524 10.93C6.55924 11.1784 6.59524 11.6032 6.33724 11.8612C6.23835 11.9641 6.10369 12.0249 5.96116 12.0312C5.81864 12.0374 5.67917 11.9886 5.57164 11.8948C4.88746 11.2761 4.34057 10.5209 3.96625 9.67778C3.59193 8.83469 3.39851 7.92249 3.39844 7.00004C3.39712 6.12712 3.56961 5.26268 3.90584 4.45712C4.24208 3.65155 4.73533 2.92099 5.35684 2.30804ZM13.8744 3.23924C13.6284 2.98724 13.6032 2.57684 13.8528 2.32724C13.9547 2.22031 14.0948 2.15821 14.2425 2.15461C14.3901 2.15101 14.5331 2.2062 14.64 2.30804C15.2616 2.92099 15.7548 3.65155 16.091 4.45712C16.4273 5.26268 16.5998 6.12712 16.5984 7.00004C16.5987 7.9226 16.4055 8.83497 16.0314 9.67828C15.6573 10.5216 15.1106 11.2771 14.4264 11.896C14.3185 11.9902 14.1783 12.039 14.0352 12.0323C13.8921 12.0256 13.7571 11.9639 13.6584 11.86C13.4016 11.6032 13.4376 11.1784 13.7016 10.93C14.2374 10.4252 14.6643 9.81618 14.9561 9.14036C15.2479 8.46453 15.3984 7.73617 15.3984 7.00004C15.3987 5.59598 14.852 4.24704 13.8744 3.23924ZM9.99844 5.50004C9.60062 5.50004 9.21909 5.65808 8.93778 5.93938C8.65648 6.22069 8.49844 6.60222 8.49844 7.00004C8.49844 7.39787 8.65648 7.7794 8.93778 8.0607C9.21909 8.34201 9.60062 8.50004 9.99844 8.50004C10.3963 8.50004 10.7778 8.34201 11.0591 8.0607C11.3404 7.7794 11.4984 7.39787 11.4984 7.00004C11.4984 6.60222 11.3404 6.22069 11.0591 5.93938C10.7778 5.65808 10.3963 5.50004 9.99844 5.50004Z"
                      fill="#666666"
                    />
                  </svg>
                </span>
                <span>Invite</span>
              </a>
            </li> */}
              {/* <li className="flex flex-align-center flex-justify-center">
              <a className="test">
                <span className="menu-icon">
                  <svg
                    width="20"
                    height="15"
                    viewBox="0 0 20 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.22204 0.200841C3.33074 0.0953572 3.47688 0.0373636 3.62833 0.0396139C3.77978 0.0418643 3.92413 0.104174 4.02964 0.212841C4.14443 0.333447 4.20734 0.494257 4.20488 0.660737C4.20241 0.827217 4.13475 0.986091 4.01644 1.10324C2.4649 2.67343 1.59593 4.79261 1.59844 7.00004C1.59844 9.38804 2.59444 11.5432 4.19524 13.072C4.25677 13.1293 4.30633 13.1982 4.34105 13.2748C4.37577 13.3514 4.39497 13.4341 4.39754 13.5181C4.4001 13.6021 4.38599 13.6858 4.356 13.7644C4.32602 13.8429 4.28076 13.9147 4.22284 13.9756C4.11961 14.0823 3.97886 14.1444 3.83052 14.1489C3.68217 14.1534 3.53792 14.0999 3.42844 13.9996C2.47081 13.1027 1.7077 12.0186 1.18648 10.8145C0.665252 9.61045 0.397026 8.3121 0.398443 7.00004C0.398443 4.34324 1.47844 1.93844 3.22204 0.200841ZM15.9804 1.10324C15.8623 0.985932 15.7949 0.826971 15.7926 0.660491C15.7904 0.494012 15.8535 0.333291 15.9684 0.212841C16.0739 0.104539 16.218 0.0424618 16.3692 0.0402124C16.5203 0.0379631 16.6662 0.0957252 16.7748 0.200841C17.6708 1.09182 18.3816 2.15131 18.8662 3.31825C19.3508 4.48518 19.5996 5.73648 19.5984 7.00004C19.5984 9.76004 18.4344 12.2488 16.5684 13.9996C16.459 14.0999 16.3147 14.1534 16.1664 14.1489C16.018 14.1444 15.8773 14.0823 15.774 13.9756C15.7163 13.9147 15.6712 13.843 15.6413 13.7646C15.6114 13.6861 15.5974 13.6026 15.6 13.5187C15.6025 13.4348 15.6217 13.3523 15.6563 13.2758C15.6909 13.1994 15.7403 13.1305 15.8016 13.0732C16.6235 12.2898 17.2776 11.3474 17.724 10.3034C18.1704 9.25939 18.3998 8.1355 18.3984 7.00004C18.4013 4.7922 17.5323 2.67372 15.9804 1.10324ZM5.35684 2.30804C5.46378 2.2062 5.60679 2.15101 5.75442 2.15461C5.90205 2.15821 6.0422 2.22031 6.14404 2.32724C6.39364 2.57684 6.36844 2.98724 6.12244 3.23924C5.14484 4.24704 4.5982 5.59598 4.59844 7.00004C4.59844 8.54804 5.25004 9.94484 6.29524 10.93C6.55924 11.1784 6.59524 11.6032 6.33724 11.8612C6.23835 11.9641 6.10369 12.0249 5.96116 12.0312C5.81864 12.0374 5.67917 11.9886 5.57164 11.8948C4.88746 11.2761 4.34057 10.5209 3.96625 9.67778C3.59193 8.83469 3.39851 7.92249 3.39844 7.00004C3.39712 6.12712 3.56961 5.26268 3.90584 4.45712C4.24208 3.65155 4.73533 2.92099 5.35684 2.30804ZM13.8744 3.23924C13.6284 2.98724 13.6032 2.57684 13.8528 2.32724C13.9547 2.22031 14.0948 2.15821 14.2425 2.15461C14.3901 2.15101 14.5331 2.2062 14.64 2.30804C15.2616 2.92099 15.7548 3.65155 16.091 4.45712C16.4273 5.26268 16.5998 6.12712 16.5984 7.00004C16.5987 7.9226 16.4055 8.83497 16.0314 9.67828C15.6573 10.5216 15.1106 11.2771 14.4264 11.896C14.3185 11.9902 14.1783 12.039 14.0352 12.0323C13.8921 12.0256 13.7571 11.9639 13.6584 11.86C13.4016 11.6032 13.4376 11.1784 13.7016 10.93C14.2374 10.4252 14.6643 9.81618 14.9561 9.14036C15.2479 8.46453 15.3984 7.73617 15.3984 7.00004C15.3987 5.59598 14.852 4.24704 13.8744 3.23924ZM9.99844 5.50004C9.60062 5.50004 9.21909 5.65808 8.93778 5.93938C8.65648 6.22069 8.49844 6.60222 8.49844 7.00004C8.49844 7.39787 8.65648 7.7794 8.93778 8.0607C9.21909 8.34201 9.60062 8.50004 9.99844 8.50004C10.3963 8.50004 10.7778 8.34201 11.0591 8.0607C11.3404 7.7794 11.4984 7.39787 11.4984 7.00004C11.4984 6.60222 11.3404 6.22069 11.0591 5.93938C10.7778 5.65808 10.3963 5.50004 9.99844 5.50004Z"
                      fill="#666666"
                    />
                  </svg>
                </span>
                <span>EasyCast</span>
              </a>
            </li> */}
              {/* <li className="flex flex-align-center flex-justify-center">
                <a>
                  <span className="menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                    >
                      <path
                        d="M7.25 16.3125C8.25102 16.3125 9.0625 15.501 9.0625 14.5C9.0625 13.499 8.25102 12.6875 7.25 12.6875C6.24898 12.6875 5.4375 13.499 5.4375 14.5C5.4375 15.501 6.24898 16.3125 7.25 16.3125Z"
                        fill="#666666"
                      />
                      <path
                        d="M14.5 16.3125C15.501 16.3125 16.3125 15.501 16.3125 14.5C16.3125 13.499 15.501 12.6875 14.5 12.6875C13.499 12.6875 12.6875 13.499 12.6875 14.5C12.6875 15.501 13.499 16.3125 14.5 16.3125Z"
                        fill="#666666"
                      />
                      <path
                        d="M21.75 16.3125C22.751 16.3125 23.5625 15.501 23.5625 14.5C23.5625 13.499 22.751 12.6875 21.75 12.6875C20.749 12.6875 19.9375 13.499 19.9375 14.5C19.9375 15.501 20.749 16.3125 21.75 16.3125Z"
                        fill="#666666"
                      />
                    </svg>
                  </span>
                  <span>More</span>
                </a>
              </li> */}
            </ul>
            <ul className="flex flex-align-center quick-actions">
              <li
                className="flex flex-align-center flex-justify-center"
                onClick={videoToggle}
              >
                <a>
                  <span className="menu-icon">
                    {video ? (
                      <svg
                        width="20"
                        height="14"
                        viewBox="0 0 20 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="2"
                          y="2"
                          width="11"
                          height="10"
                          rx="1"
                          fill="#333333"
                        />
                        <path
                          d="M7.305 5.48633C7.857 5.48633 8.305 5.03833 8.305 4.48633C8.305 3.93433 7.857 3.48633 7.305 3.48633H4C3.448 3.48633 3 3.93433 3 4.48633C3 5.03833 3.448 5.48633 4 5.48633H7.305Z"
                          fill="white"
                          className="camera-line"
                        />
                        <path
                          d="M19.4932 0.561109C19.1762 0.384109 18.7862 0.394109 18.4782 0.587109L14.7412 2.92111C14.4952 1.29311 13.0992 0.0371094 11.4042 0.0371094H3.38019C1.51219 0.0371094 -0.0078125 1.55711 -0.0078125 3.42511V5.74211C-0.0078125 6.29411 0.440188 6.74211 0.992188 6.74211C1.54419 6.74211 1.99219 6.29411 1.99219 5.74211V3.42511C1.99219 2.65911 2.61519 2.03711 3.38019 2.03711H11.4052C12.1712 2.03711 12.7932 2.66011 12.7932 3.42511V10.5741C12.7932 11.3401 12.1702 11.9621 11.4052 11.9621H3.38019C2.61419 11.9621 1.99219 11.3391 1.99219 10.5741V9.15711C1.99219 8.60511 1.54419 8.15711 0.992188 8.15711C0.440188 8.15711 -0.0078125 8.60511 -0.0078125 9.15711V10.5741C-0.0078125 12.4421 1.51219 13.9621 3.38019 13.9621H11.4052C13.1012 13.9621 14.4972 12.7051 14.7422 11.0771L18.4782 13.4121C18.6402 13.5131 18.8242 13.5641 19.0082 13.5641C19.1752 13.5641 19.3412 13.5221 19.4932 13.4391C19.8112 13.2631 20.0082 12.9281 20.0082 12.5641V1.43511C20.0082 1.07211 19.8112 0.737109 19.4932 0.561109ZM18.0082 10.7601L14.7932 8.75011V5.24811L18.0082 3.23911V10.7601Z"
                          fill="#333333"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="4"
                          y="7"
                          width="11"
                          height="10"
                          rx="1"
                          fill="#333333"
                        />
                        <path
                          d="M9.305 10.4863C9.857 10.4863 10.305 10.0383 10.305 9.48633C10.305 8.93433 9.857 8.48633 9.305 8.48633H6C5.448 8.48633 5 8.93433 5 9.48633C5 10.0383 5.448 10.4863 6 10.4863H9.305Z"
                          fill="white"
                        />
                        <path
                          d="M21.4932 5.56111C21.1762 5.38411 20.7862 5.39411 20.4782 5.58711L16.7412 7.92111C16.4952 6.29311 15.0992 5.03711 13.4042 5.03711H5.38019C3.51219 5.03711 1.99219 6.55711 1.99219 8.42511V10.7421C1.99219 11.2941 2.44019 11.7421 2.99219 11.7421C3.54419 11.7421 3.99219 11.2941 3.99219 10.7421V8.42511C3.99219 7.65911 4.61519 7.03711 5.38019 7.03711H13.4052C14.1712 7.03711 14.7932 7.66011 14.7932 8.42511V15.5741C14.7932 16.3401 14.1702 16.9621 13.4052 16.9621H5.38019C4.61419 16.9621 3.99219 16.3391 3.99219 15.5741V14.1571C3.99219 13.6051 3.54419 13.1571 2.99219 13.1571C2.44019 13.1571 1.99219 13.6051 1.99219 14.1571V15.5741C1.99219 17.4421 3.51219 18.9621 5.38019 18.9621H13.4052C15.1012 18.9621 16.4972 17.7051 16.7422 16.0771L20.4782 18.4121C20.6402 18.5131 20.8242 18.5641 21.0082 18.5641C21.1752 18.5641 21.3412 18.5221 21.4932 18.4391C21.8112 18.2631 22.0082 17.9281 22.0082 17.5641V6.43511C22.0082 6.07211 21.8112 5.73711 21.4932 5.56111ZM20.0082 15.7601L16.7932 13.7501V10.2481L20.0082 8.23911V15.7601Z"
                          fill="#333333"
                        />
                        <path
                          d="M2 3L21 22"
                          stroke="#E6E9EF"
                          stroke-width="3"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2 3L21 22"
                          className="line"
                          stroke="#333333"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    )}
                  </span>
                  <span>Camera</span>
                </a>
                {/* put code here */}
                <button
                  type="button"
                  className="only-icon mic-icon"
                  onClick={toggleCameraDropdown}
                >
                  <svg
                    width="11"
                    height="6"
                    viewBox="0 0 11 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.80078 1.19336L5.53411 4.80626L1.26745 1.19336"
                      stroke="#666666"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <div
                  onClick={(e) => e.stopPropagation()}
                  className={`ew-video-controls-box mic-settings ${
                    isDropdownCameraActive ? "open-dropdown" : ""
                  }`}
                >
                  <CameraSettings />
                </div>
              </li>
              <li className="flex flex-align-center flex-justify-center">
                <a onClick={muteToggle1}>
                  <span className="menu-icon">
                    {muted == false ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9978 1.71436C10.9748 1.71436 9.99371 2.12073 9.27036 2.84409C8.547 3.56744 8.14062 4.54852 8.14062 5.5715V12.4286C8.14062 12.9352 8.24039 13.4367 8.43423 13.9047C8.62807 14.3727 8.91219 14.7979 9.27036 15.1561C9.62853 15.5142 10.0537 15.7983 10.5217 15.9922C10.9897 16.186 11.4912 16.2858 11.9978 16.2858C12.5043 16.2858 13.0059 16.186 13.4738 15.9922C13.9418 15.7983 14.367 15.5142 14.7252 15.1561C15.0833 14.7979 15.3675 14.3727 15.5613 13.9047C15.7551 13.4367 15.8549 12.9352 15.8549 12.4286V5.5715C15.8549 4.54852 15.4485 3.56744 14.7252 2.84409C14.0018 2.12073 13.0207 1.71436 11.9978 1.71436ZM6.42634 11.7858C6.42634 11.6153 6.35861 11.4518 6.23805 11.3312C6.11749 11.2107 5.95398 11.1429 5.78348 11.1429C5.61299 11.1429 5.44947 11.2107 5.32891 11.3312C5.20835 11.4518 5.14063 11.6153 5.14063 11.7858V12.4286C5.14058 14.136 5.77748 15.782 6.92677 17.0446C8.07607 18.3073 9.65506 19.0957 11.3549 19.2558V21.6429C11.3549 21.8134 11.4226 21.9769 11.5432 22.0975C11.6638 22.2181 11.8273 22.2858 11.9978 22.2858C12.1683 22.2858 12.3318 22.2181 12.4523 22.0975C12.5729 21.9769 12.6406 21.8134 12.6406 21.6429V19.2558C14.3405 19.0957 15.9195 18.3073 17.0688 17.0446C18.2181 15.782 18.855 14.136 18.8549 12.4286V11.7858C18.8549 11.6153 18.7872 11.4518 18.6666 11.3312C18.5461 11.2107 18.3826 11.1429 18.2121 11.1429C18.0416 11.1429 17.878 11.2107 17.7575 11.3312C17.6369 11.4518 17.5692 11.6153 17.5692 11.7858V12.4286C17.5692 13.9063 16.9822 15.3234 15.9374 16.3682C14.8925 17.4131 13.4754 18.0001 11.9978 18.0001C10.5201 18.0001 9.10302 17.4131 8.05817 16.3682C7.01333 15.3234 6.42634 13.9063 6.42634 12.4286V11.7858Z"
                          fill="#333333"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9978 1.71436C10.9748 1.71436 9.99371 2.12073 9.27036 2.84409C8.547 3.56744 8.14062 4.54852 8.14062 5.5715V12.4286C8.14062 12.9352 8.24039 13.4367 8.43423 13.9047C8.62807 14.3727 8.91219 14.7979 9.27036 15.1561C9.62852 15.5142 10.0537 15.7983 10.5217 15.9922C10.9897 16.186 11.4912 16.2858 11.9978 16.2858C12.5043 16.2858 13.0059 16.186 13.4738 15.9922C13.9418 15.7983 14.367 15.5142 14.7252 15.1561C15.0833 14.7979 15.3675 14.3727 15.5613 13.9047C15.7551 13.4367 15.8549 12.9352 15.8549 12.4286V5.5715C15.8549 4.54852 15.4485 3.56744 14.7252 2.84409C14.0018 2.12073 13.0207 1.71436 11.9978 1.71436ZM6.42634 11.7858C6.42634 11.6153 6.35861 11.4518 6.23805 11.3312C6.11749 11.2107 5.95398 11.1429 5.78348 11.1429C5.61299 11.1429 5.44947 11.2107 5.32891 11.3312C5.20835 11.4518 5.14063 11.6153 5.14063 11.7858V12.4286C5.14058 14.136 5.77748 15.782 6.92677 17.0446C8.07607 18.3073 9.65506 19.0957 11.3549 19.2558V21.6429C11.3549 21.8134 11.4226 21.9769 11.5432 22.0975C11.6638 22.2181 11.8273 22.2858 11.9978 22.2858C12.1683 22.2858 12.3318 22.2181 12.4523 22.0975C12.5729 21.9769 12.6406 21.8134 12.6406 21.6429V19.2558C14.3405 19.0957 15.9195 18.3073 17.0688 17.0446C18.2181 15.782 18.855 14.136 18.8549 12.4286V11.7858C18.8549 11.6153 18.7872 11.4518 18.6666 11.3312C18.5461 11.2107 18.3825 11.1429 18.2121 11.1429C18.0416 11.1429 17.878 11.2107 17.7575 11.3312C17.6369 11.4518 17.5692 11.6153 17.5692 11.7858V12.4286C17.5692 13.9063 16.9822 15.3234 15.9374 16.3682C14.8925 17.4131 13.4754 18.0001 11.9978 18.0001C10.5201 18.0001 9.10302 17.4131 8.05817 16.3682C7.01333 15.3234 6.42634 13.9063 6.42634 12.4286V11.7858Z"
                          fill="#333333"
                        />
                        <path
                          d="M3.63281 2.55371L20.5411 21.7165"
                          stroke="white"
                          stroke-width="3"
                          stroke-linecap="round"
                        />
                        <path
                          d="M3.63281 2.55371L20.5411 21.7165"
                          className="line"
                          stroke="#333333"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    )}
                  </span>
                  <span>Mic</span>
                </a>
                <button
                  type="button"
                  className="only-icon mic-icon"
                  onClick={toggleMicDropdown}
                >
                  <svg
                    width="11"
                    height="6"
                    viewBox="0 0 11 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.80078 1.19336L5.53411 4.80626L1.26745 1.19336"
                      stroke="#666666"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <div
                  onClick={(e) => e.stopPropagation()}
                  className={`ew-video-controls-box mic-settings ${
                    isDropdownMicActive ? "open-dropdown" : ""
                  }`}
                >
                  <AudioInputSelector />
                  <div className="ew-form-field marginb-0">
                    <label htmlFor="dropdown">Speakers</label>
                    <span className="label-sub-heading">
                      Select your preferred device for Speakers
                    </span>
                    <div className="mic-volume">
                      <span className="icon">
                        <img src={speakerIcon} alt="" />
                      </span>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={volume * 100}
                        onChange={handleVolumeChange}
                        className="custom-range"
                        style={{ width: "100%", cursor: "ew-resize" }}
                      />
                    </div>
                    <AudioOutputSelector />
                  </div>
                  <div className="ew-form-field marginb-0 mic-actions">
                    <button
                      onClick={(event) => {
                        event.stopPropagation();
                        handleEnableNoiseReduction();
                      }}
                      type="button"
                      className="btn flex flex-center noise-reduction"
                    >
                      <img src={noiseReduction} alt="" />
                      {stateData?.publishStreamObj?.isNoiseReductionEnabled
                        ? " Disable Noise Reduction"
                        : "Enable Noise Reduction"}
                    </button>
                    <button
                      type="button"
                      className="btn"
                      onClick={goToAudioSettings}
                    >
                      Audio Settings
                    </button>
                  </div>
                </div>
              </li>
              {IsScreeen ? (
                <li
                  className="flex flex-align-center flex-justify-center screen-sharing stop-share"
                  onClick={stopScreenShare}
                >
                  <a href="#">
                    <span className="menu-icon">
                      <svg
                        style={{ display: "none" }}
                        width="22"
                        height="16"
                        viewBox="0 0 22 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.64342 0.284668C2.13193 0.284668 1.64139 0.487856 1.27971 0.849533C0.918032 1.21121 0.714844 1.70175 0.714844 2.21324V13.7847C0.714731 14.038 0.764532 14.2889 0.861402 14.523C0.958271 14.757 1.10031 14.9698 1.27941 15.1489C1.4585 15.3281 1.67114 15.4702 1.90518 15.5672C2.13923 15.6642 2.39008 15.7141 2.64342 15.7141H19.3577C19.8692 15.7141 20.3597 15.5109 20.7214 15.1492C21.0831 14.7876 21.2863 14.297 21.2863 13.7855V2.2141C21.2863 1.70261 21.0831 1.21207 20.7214 0.850391C20.3597 0.488713 19.8692 0.285525 19.3577 0.285525L2.64342 0.284668ZM11.4531 3.57695L14.2431 6.36695C14.3602 6.48825 14.4249 6.65067 14.4234 6.81923C14.4218 6.98778 14.3541 7.14899 14.2349 7.26812C14.1156 7.38726 13.9544 7.45479 13.7858 7.45618C13.6172 7.45756 13.4549 7.39269 13.3337 7.27553L11.6417 5.58352V11.9667C11.6417 12.1372 11.574 12.3007 11.4534 12.4212C11.3329 12.5418 11.1693 12.6095 10.9988 12.6095C10.8283 12.6095 10.6648 12.5418 10.5443 12.4212C10.4237 12.3007 10.356 12.1372 10.356 11.9667V5.58524L8.66742 7.27553C8.60814 7.33695 8.53723 7.38596 8.45881 7.41969C8.3804 7.45341 8.29605 7.47119 8.2107 7.47197C8.12534 7.47275 8.04068 7.45653 7.96166 7.42424C7.88264 7.39195 7.81084 7.34425 7.75045 7.28392C7.69007 7.22359 7.6423 7.15184 7.60994 7.07285C7.57758 6.99386 7.56127 6.90922 7.56197 6.82386C7.56267 6.7385 7.58037 6.65414 7.61402 6.57569C7.64768 6.49724 7.69662 6.42628 7.75799 6.36695L10.5437 3.57781C10.6034 3.51807 10.6743 3.47068 10.7523 3.43835C10.8303 3.40602 10.914 3.38938 10.9984 3.38938C11.0829 3.38938 11.1665 3.40602 11.2445 3.43835C11.3225 3.47068 11.3934 3.51722 11.4531 3.57695Z"
                          fill="#333333"
                        />
                      </svg>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.90039 5.2998C5.10474 5.2998 4.34168 5.61588 3.77907 6.17848C3.21646 6.74109 2.90039 7.50416 2.90039 8.2998V16.6998C2.90039 17.4955 3.21646 18.2585 3.77907 18.8211C4.34168 19.3837 5.10474 19.6998 5.90039 19.6998H19.1004C19.896 19.6998 20.6591 19.3837 21.2217 18.8211C21.7843 18.2585 22.1004 17.4955 22.1004 16.6998V8.2998C22.1004 7.50416 21.7843 6.74109 21.2217 6.17848C20.6591 5.61588 19.896 5.2998 19.1004 5.2998H5.90039ZM9.07559 9.075C9.13133 9.01913 9.19754 8.9748 9.27043 8.94455C9.34332 8.9143 9.42147 8.89873 9.50039 8.89873C9.57931 8.89873 9.65746 8.9143 9.73035 8.94455C9.80325 8.9748 9.86946 9.01913 9.92519 9.075L12.5004 11.6514L15.0756 9.075C15.1883 8.96234 15.3411 8.89905 15.5004 8.89905C15.6597 8.89905 15.8125 8.96234 15.9252 9.075C16.0379 9.18767 16.1011 9.34047 16.1011 9.4998C16.1011 9.65914 16.0379 9.81194 15.9252 9.9246L13.3488 12.4998L15.9252 15.075C16.0379 15.1877 16.1011 15.3405 16.1011 15.4998C16.1011 15.6591 16.0379 15.8119 15.9252 15.9246C15.8125 16.0373 15.6597 16.1006 15.5004 16.1006C15.3411 16.1006 15.1883 16.0373 15.0756 15.9246L12.5004 13.3482L9.92519 15.9246C9.81269 16.0373 9.66003 16.1006 9.50081 16.1007C9.3416 16.1009 9.18886 16.0377 9.07619 15.9252C8.96353 15.8127 8.90017 15.66 8.90006 15.5008C8.89994 15.3416 8.96309 15.1889 9.07559 15.0762L11.652 12.4998L9.07559 9.9246C9.01971 9.86887 8.97538 9.80266 8.94514 9.72977C8.91489 9.65687 8.89932 9.57873 8.89932 9.4998C8.89932 9.42088 8.91489 9.34274 8.94514 9.26984C8.97538 9.19695 9.01971 9.13074 9.07559 9.075Z"
                          fill="#E44258"
                        />
                      </svg>
                    </span>
                    <span>Stop Share</span>
                  </a>
                </li>
              ) : (
                <li
                  className="flex flex-align-center flex-justify-center"
                  onClick={toggleScreenShare}
                >
                  <a>
                    <span className="menu-icon">
                      <svg
                        width="22"
                        height="16"
                        viewBox="0 0 22 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.64342 0.284668C2.13193 0.284668 1.64139 0.487856 1.27971 0.849533C0.918032 1.21121 0.714844 1.70175 0.714844 2.21324V13.7847C0.714731 14.038 0.764532 14.2889 0.861402 14.523C0.958271 14.757 1.10031 14.9698 1.27941 15.1489C1.4585 15.3281 1.67114 15.4702 1.90518 15.5672C2.13923 15.6642 2.39008 15.7141 2.64342 15.7141H19.3577C19.8692 15.7141 20.3597 15.5109 20.7214 15.1492C21.0831 14.7876 21.2863 14.297 21.2863 13.7855V2.2141C21.2863 1.70261 21.0831 1.21207 20.7214 0.850391C20.3597 0.488713 19.8692 0.285525 19.3577 0.285525L2.64342 0.284668ZM11.4531 3.57695L14.2431 6.36695C14.3602 6.48825 14.4249 6.65067 14.4234 6.81923C14.4218 6.98778 14.3541 7.14899 14.2349 7.26812C14.1156 7.38726 13.9544 7.45479 13.7858 7.45618C13.6172 7.45756 13.4549 7.39269 13.3337 7.27553L11.6417 5.58352V11.9667C11.6417 12.1372 11.574 12.3007 11.4534 12.4212C11.3329 12.5418 11.1693 12.6095 10.9988 12.6095C10.8283 12.6095 10.6648 12.5418 10.5443 12.4212C10.4237 12.3007 10.356 12.1372 10.356 11.9667V5.58524L8.66742 7.27553C8.60814 7.33695 8.53723 7.38596 8.45881 7.41969C8.3804 7.45341 8.29605 7.47119 8.2107 7.47197C8.12534 7.47275 8.04068 7.45653 7.96166 7.42424C7.88264 7.39195 7.81084 7.34425 7.75045 7.28392C7.69007 7.22359 7.6423 7.15184 7.60994 7.07285C7.57758 6.99386 7.56127 6.90922 7.56197 6.82386C7.56267 6.7385 7.58037 6.65414 7.61402 6.57569C7.64768 6.49724 7.69662 6.42628 7.75799 6.36695L10.5437 3.57781C10.6034 3.51807 10.6743 3.47068 10.7523 3.43835C10.8303 3.40602 10.914 3.38938 10.9984 3.38938C11.0829 3.38938 11.1665 3.40602 11.2445 3.43835C11.3225 3.47068 11.3934 3.51722 11.4531 3.57695Z"
                          fill="#333333"
                        />
                      </svg>
                    </span>
                    <span>Screen</span>
                  </a>
                </li>
              )}
              {/* <li
              className="flex flex-align-center flex-justify-center"
              onClick={toggleScreenShare}
            >
              <a>
                <span className="menu-icon">
                  <svg
                    width="22"
                    height="16"
                    viewBox="0 0 22 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.64342 0.284668C2.13193 0.284668 1.64139 0.487856 1.27971 0.849533C0.918032 1.21121 0.714844 1.70175 0.714844 2.21324V13.7847C0.714731 14.038 0.764532 14.2889 0.861402 14.523C0.958271 14.757 1.10031 14.9698 1.27941 15.1489C1.4585 15.3281 1.67114 15.4702 1.90518 15.5672C2.13923 15.6642 2.39008 15.7141 2.64342 15.7141H19.3577C19.8692 15.7141 20.3597 15.5109 20.7214 15.1492C21.0831 14.7876 21.2863 14.297 21.2863 13.7855V2.2141C21.2863 1.70261 21.0831 1.21207 20.7214 0.850391C20.3597 0.488713 19.8692 0.285525 19.3577 0.285525L2.64342 0.284668ZM11.4531 3.57695L14.2431 6.36695C14.3602 6.48825 14.4249 6.65067 14.4234 6.81923C14.4218 6.98778 14.3541 7.14899 14.2349 7.26812C14.1156 7.38726 13.9544 7.45479 13.7858 7.45618C13.6172 7.45756 13.4549 7.39269 13.3337 7.27553L11.6417 5.58352V11.9667C11.6417 12.1372 11.574 12.3007 11.4534 12.4212C11.3329 12.5418 11.1693 12.6095 10.9988 12.6095C10.8283 12.6095 10.6648 12.5418 10.5443 12.4212C10.4237 12.3007 10.356 12.1372 10.356 11.9667V5.58524L8.66742 7.27553C8.60814 7.33695 8.53723 7.38596 8.45881 7.41969C8.3804 7.45341 8.29605 7.47119 8.2107 7.47197C8.12534 7.47275 8.04068 7.45653 7.96166 7.42424C7.88264 7.39195 7.81084 7.34425 7.75045 7.28392C7.69007 7.22359 7.6423 7.15184 7.60994 7.07285C7.57758 6.99386 7.56127 6.90922 7.56197 6.82386C7.56267 6.7385 7.58037 6.65414 7.61402 6.57569C7.64768 6.49724 7.69662 6.42628 7.75799 6.36695L10.5437 3.57781C10.6034 3.51807 10.6743 3.47068 10.7523 3.43835C10.8303 3.40602 10.914 3.38938 10.9984 3.38938C11.0829 3.38938 11.1665 3.40602 11.2445 3.43835C11.3225 3.47068 11.3934 3.51722 11.4531 3.57695Z"
                      fill="#333333"
                    />
                  </svg>
                </span>
                <span>Screen</span>
              </a>
            </li> */}
            </ul>
          </div>
          {stateData.publishStreamObj?.isAdmin && (
            <div
              className="ew-event-actions flex flex-align-center flex-justify-center"
              ref={dropdownRef}
            >
              {!stateData?.publishStreamObj?.isLiveGo &&
                stateData.publishStreamObj?.isAdmin && (
                  <button
                    type="button"
                    className="flex flex-center button go-live"
                    onClick={handleIsLiveClick}
                  >
                    Go Live
                  </button>
                )}
              {stateData.publishStreamObj.isLiveGo && (
                <div className="flex exit-actions-btn">
                  <button
                    type="button"
                    className="flex flex-center button warning-button exit-btn"
                    onClick={toggleExitDropdown}
                  >
                    Leave
                  </button>
                  <button
                    type="button"
                    className="flex flex-center button warning-button exit-btn exit-dropdown"
                    onClick={toggleExitDropdown}
                  >
                    <img src={dropdownArrow} alt="" />
                    {/* <img src={playIcon} alt="" /> */}
                  </button>
                </div>
              )}
              {!stateData.publishStreamObj.isLiveGo && (
                <div className="flex flex-align-center">
                  <div className="ew-event-actions flex flex-align-center flex-justify-center">
                    <div className="flex exit-actions-btn">
                      <button
                        type="button"
                        className="flex flex-center button warning-button exit-btn"
                        onClick={() => {
                          onOpenConfirmationModel("leave");
                        }}
                      >
                        Exit
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={`dropdown ${
                  isDropdownEventActive ? "open-dropdown" : ""
                }`}
              >
                {stateData.publishStreamObj.isLiveGo && (
                  <ul>
                    <li
                      onClick={() => {
                        onOpenConfirmationModel("EndSession");
                      }}
                    >
                      <a>
                        <img src={endSession} alt="" />
                        End Session
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        onOpenConfirmationModel("leave");
                      }}
                    >
                      <a>
                        <img src={leaveSession} alt="" />
                        Leave
                      </a>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          )}
          {!stateData.publishStreamObj?.isAdmin && (
            <div className="flex flex-align-center">
              <div className="ew-event-actions flex flex-align-center flex-justify-center">
                <div className="flex exit-actions-btn">
                  <button
                    type="button"
                    className="flex flex-center button warning-button exit-btn"
                    onClick={() => {
                      onOpenConfirmationModel("leave");
                    }}
                  >
                    Leave
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {isSettingPopupOpen && (
          <Settings
            togglePopup={settingTogglePopup}
            activeTabProp={activeTabProp}
          />
        )}
        {/* {isInvitePopUp && <Invite />} */}

        <EasyCastPopup
          isEasyCastOpen={isEasyCastOpen}
          onEasyCastClose={closeEasyCastPopup}
        />
      </div>

      {isConfirmationOpen && (
        <ConfirmationPopup
          isEndSessionOrLeave={isEndSessionOrLeave}
          isConfirmationOpen={isConfirmationOpen}
          onCloseConfirmationPopUp={onCloseConfirmationPopUp}
          SessionHandle={
            isEndSessionOrLeave === "EndSession"
              ? leaveSessionHandle
              : leaveroom
          }
        />
      )}
      {isScreenShareDeniedOpen && (
        <ScreenShareDeniedPopup
          onScreenShareDeniedClose={onScreenShareDeniedClose}
          isScreenShareDeniedOpen={isScreenShareDeniedOpen}
          topic={"Screen Sharing Denied"}
          header={"Someone else is sharing"}
          content={
            "The host isn't allowing multiple presenter sharing for this webinar."
          }
        />
      )}
    </>
  );
};
